
import {
    CHANGE_CLINICAL_TRIAL_FILTER,
    CLEAR_CLINICAL_TRIAL_FILTER
} from '../../actions/types';

const initialState = {
    sponsor: [],
    intervention: [],
    status: [],
    country: [],
    isFilterActive: false
};

const clearFilters = (state, action) => {
    return {

        sponsor: [],
        intervention: [],
        status: [],
        country: [],
        isFilterActive: false

    }
}


const setChanges = (state, action) => {

    let {
        sponsor,
        intervention,
        status,
        country
    } = action.payload;

    return {
        ...state,
        sponsor,
        intervention,
        status,
        country,
        isFilterActive: true
    }

}


export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_CLINICAL_TRIAL_FILTER:
            return setChanges(state, action);
            break;
        
        case CLEAR_CLINICAL_TRIAL_FILTER:
            return clearFilters(state, action);
            break;
        default:
            return state;
            break;
    }
}